import { useNavigate } from 'react-router-dom';
import { useGetSubscriptionPlansQuery } from '../slices/subscriptionsApiSlice';
import Meta from '../components/Meta';

const SubscriptionScreen = () => {
    const navigate = useNavigate();
    const { data: plans, isLoading, isError, error } = useGetSubscriptionPlansQuery();

    // ローディング中のUI表示
    if (isLoading) return <div className="subscription-loading">Loading...</div>;
    // エラーがあった場合のUI表示
    if (isError) return <div className="subscription-error">Error: {error.message}</div>;

    const handleSelectPlan = (id) => {
        // サブスクリプション選択処理（例: サーバーに保存）
        navigate(`/subscription/${id}/join`); // 次の画面へのナビゲート
    };

    // カスタムIDマッピング（plan.idに基づいて名前を割り当て）
    const getCustomPlanName = (planId, index) => {
        // インデックスベースで名前を割り当て（または plan.id に基づいてマッピング）
        const customNames = ['LIGHT', 'STANDARD', 'PREMIUM'];
        return customNames[index] || `plan-${index + 1}`;
    };

    return (
        <div className="subscription-container">
            <Meta
                title="サブスクリプション | ふるぷら"
                description="ふるぷらのサブスクリプション一覧ページです。"
                keywords={['サブスクリプション', 'プラン', '古着', 'レンタル', 'ファッション', 'おしゃれ', 'ふるぷら']}
            />
            <div className="subscription-content">
                <h1 className="subscription-content-title">
                    サブスクで古着を<br />
                    もっと楽しもう
                </h1>
                <div className="subscription-content-grid">
                    {plans.map((plan, index) => {
                        const customPlanName = getCustomPlanName(plan.id, index);
                        const isFirst = index === 0;
                        const isLast = index === plans.length - 1;
                        
                        return (
                            <div className="subscription-content-grid-wrapper" key={plan.id}>
                                {/* すべてのカードにラベルエリアを確保（STANDARDは空） */}
                                <div className="subscription-content-grid-wrapper-label">
                                    {isFirst && '＼古着初心者さんにおすすめ／'}
                                    {isLast && '＼古着好きさんにおすすめ／'}
                                    {!isFirst && !isLast && '\u00A0'}
                                </div>
                                <div className={`subscription-content-grid-wrapper-card subscription-content-grid-wrapper-card--${customPlanName.toLowerCase()}`}>
                                    {customPlanName === 'STANDARD' && (
                                        <div className="subscription-content-grid-wrapper-card-badge">
                                            一番<br/>
                                            人気
                                        </div>
                                    )}
                                    <div className={`subscription-content-grid-wrapper-card-header subscription-content-grid-wrapper-card-header--${customPlanName.toLowerCase()}`}>
                                        <h2>{customPlanName}</h2>
                                    </div>
                                    <div className="subscription-content-grid-wrapper-card-body">
                                        <div className="subscription-content-grid-wrapper-card-body-text">
                                            <p className="subscription-content-grid-wrapper-card-body-text-title">料金</p>
                                            <p className={`subscription-content-grid-wrapper-card-body-text-price--${customPlanName.toLowerCase()}`}>¥{plan.price}<span className="subscription-content-grid-wrapper-card-body-text-price-small">/月(税込)</span></p>
                                            <p className="subscription-content-grid-wrapper-card-body-text-title">借りられる古着の上限定価金額</p>
                                            <p className={`subscription-content-grid-wrapper-card-body-text-price--${customPlanName.toLowerCase()}`}>¥{plan.itemPriceLimit}</p>
                                            <p className="subscription-content-grid-wrapper-card-body-text-description">
                                            {plan.maxItems}着が何度でも交換可能
                                            </p>
                                        </div>
                                        <button 
                                            className="subscription-content-grid-wrapper-card-body-button" 
                                            onClick={() => handleSelectPlan(plan.id)}
                                        >
                                            詳細

                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default SubscriptionScreen;